import React, { ChangeEvent, useRef, useState } from 'react';

export const UploadButton = ( {
  setData,
}: {
  setData: ( data: string | ArrayBuffer | null | undefined ) => void;
} ) => {
  const [uploadError, setUploadError] = useState( '' );
  const uploadRef = useRef<HTMLInputElement>( null );

  const handleUpload = ( e: ChangeEvent<HTMLInputElement> ) => {
    if ( e.target.files === null ) {
      return;
    }
    const file = e.target.files[0];

    if ( file ) {
      if ( file.type !== 'text/json' ) {
        setUploadError( 'Please upload a .json file' );
      }

      const fileReader = new FileReader();
      fileReader.onload = ( event ) => {
        const contents = event?.target?.result;
        setData( contents );
      };

      e.target.value = '';
      fileReader.readAsText( file );
    } else {
      setUploadError( 'File could not be uploaded. Please try again.' );
    }
  };

  return (
    <div className='upload'>
      {/* style this however you like */}
      <button onClick={() => uploadRef.current?.click()}>
        Nahrát vlastní strukturu
      </button>

      <input
        type='file'
        ref={uploadRef}
        onChange={handleUpload}
        style={{ display: 'none' }}
      />

      {uploadError ? <p>{uploadError}</p> : null}
    </div>
  );
};
